import React, { useEffect } from 'react'
import { useFcmTokens } from '@app/lib/useFcmTokens'

/**
 * FCM Token Manager that:
 * 1. Checks user's push notification preferences before registering
 * 2. Auto-registers only when user has enabled push notifications
 * 3. Auto-deactivates when user disables push notifications or logs out
 * 4. Handles permission requests
 *
 * This component operates silently in the background and respects user preferences.
 */
export function FcmManager() {
  const { currentToken, loading, error, pushNotificationsEnabled } = useFcmTokens({
    deviceType: 'web'
  })

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      if (error) {
        console.error('FCM Token Error:', error)
      } else if (currentToken) {
        console.log('FCM Token registered:', currentToken.substring(0, 20) + '...')
      } else if (pushNotificationsEnabled === false) {
        console.log('FCM Token not registered - push notifications disabled in preferences')
      }
    }
  }, [error, currentToken, pushNotificationsEnabled])

  // No UI needed - this handles everything automatically
  return null
}

export default FcmManager
